import { Injectable } from '@angular/core';
import { HeaderFooterMachCore } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { DatePickerOptions } from '@com-delta-omnichannel/mach-core-js';
import { AemPropertyAccessor } from '../../utils/booking-stays/aem-property-accessor';

@Injectable({ providedIn: 'root' })
export class StaysDateAdapter {
  getDropDownDateOptions(aem: HeaderFooterMachCore): DatePickerOptions {
    return {
      id: 'range-date-picker',
      title: AemPropertyAccessor.getString(aem, 'dropDownDateOption.title'),
      selectionType: 'range',
      triggerElementId: 'range-date-trigger',
      footer: {
        primaryButtonLabel: AemPropertyAccessor.getString(
          aem,
          'dropDownDateOption.footer.primaryButtonLabel'
        )
      },
      dates: { dateRange: this.getDateRange() }
    };
  }

  private getDateRange(): {
    start: Date;
    end: Date;
  } {
    const today = new Date();
    const endDate = new Date(today);
    endDate.setDate(today.getDate() + 499);
    return {
      start: today,
      end: endDate
    };
  }
}
